export default {
    label_task:{
        en:"Dealers",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Dealer",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Dealer",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Dealer",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_credit_limit:{
        en:"Credit Limit",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_opening_balance:{
        en:"Opening Balance",
        bn:'ব্যবহারকারীর বিবরণ'
    },

}